export default __webpack_public_path__ + "static/media/ai.5c5ccf01.png";